































































import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import IntegrationDto from '@/models/Integrations/IntegrationDto'
import IntegrationCreate from '@/components/Integrations/IntegrationCreate.vue';
import IntegrationLogo from '@/components/Integrations/IntegrationLogo.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import IntegrationSystemIdConstants from '@/models/Integrations/IntegrationSystemIdConstants';
import ListUtils from '@/lib/listUtils';
import PageNames from '@/router/PageNames';

@Component({
  name: 'Integrations',
  components: { IntegrationCreate, IntegrationLogo }
})
export default class extends GiganautVue {
    
    async beforeMount() {
        AgencySettingsModule.updateCurrentIntegration(null);
    }

    navigateToIntegrationDetail(integration: IntegrationDto) {
        this.$router.push({ name: PageNames.AgencyIntegrationDetails, params: { integrationid: integration.id } });
    }

    get loading() {
        return AgencySettingsModule.loadingIntegrations;
    }

    get integrations() {
        return AgencySettingsModule.integrations;
    }

    integrationDescription(systemId: string) {
        return ListUtils.integrationDescription(systemId);
    }
    integrationGiganautFeatures(systemId: string) {
        return ListUtils.integrationGiganautFeatures(systemId);
    }
}
